import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const LangToggle = ({ lang, setLang }) => (
  <div className="flex rounded-full border border-white/15 p-0.5 font-mono text-[11px]" data-testid="lang-toggle">
    {["es", "en"].map((l) => (
      <button
        key={l}
        onClick={() => setLang(l)}
        className={`rounded-full px-2.5 py-1 uppercase transition-colors duration-200 ${
          lang === l ? "bg-[#FF5500] text-white" : "text-slate-400 hover:text-white"
        }`}
        data-testid={`lang-btn-${l}`}
      >
        {l}
      </button>
    ))}
  </div>
);

export const PortfolioHeader = ({ lang, setLang }) => (
  <header
    className="sticky top-0 z-40 border-b border-white/10 bg-[#081B33]/80 backdrop-blur-xl"
    data-testid="portfolio-header"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
      <Link to="/" data-testid="portfolio-home-link">
        <Logo />
      </Link>
      <div className="flex flex-wrap items-center justify-end gap-2 font-mono text-[11px] sm:text-xs">
        <span
          className="hidden items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-emerald-300 sm:flex"
          data-testid="badge-tech-lead"
        >
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
          Available for Tech Lead
        </span>
        <span
          className="hidden rounded-full border border-[#FF5500]/40 bg-[#FF5500]/10 px-3 py-1 text-[#FF7A33] md:inline"
          data-testid="badge-b2b"
        >
          B2B Solutions
        </span>
        <LangToggle lang={lang} setLang={setLang} />
      </div>
    </div>
  </header>
);

export default PortfolioHeader;
